module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/sugerencia/sugerencia.component.scss
// module id = ./src/app/productos/sugerencia/sugerencia.component.scss
// module chunks = main